import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
// import Input from '@material-ui/core/Input';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import firebase from "firebase/app"
import "firebase/firestore"
import { db } from '../firebase'

function Subscribe() {
    const [open, setOpen] = React.useState(true);
    const emailRef = React.useRef();

    const fullWidth = true;
    const maxWidth = 'sm';

    const handleClickOpen = () => {
        setOpen(true);
    };

    const addEmail = (props) => {
        // save email to database
        const docData = {
            'address': emailRef.current.value,
            'date': firebase.firestore.FieldValue.serverTimestamp()
        }
        db.collection("mailing-list").doc(emailRef.current.value).set(docData).then(() => {
            console.log("Document successfully written!")
        }).catch((error) => {
            console.error("Error writing document: ", error);
        });
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
        <Button variant="outlined" color="secondary" onClick={handleClickOpen}>
            Subscribe to our newsletter!
        </Button>
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">We are growing</DialogTitle>
            <DialogContent>
            <DialogContentText>
                At Deep Questions, we are constantly developing new features and
                making a better user experience, thanks to your feedback.
                <div style={{ marginTop: '0.5rem' }} />
                We want to offer you the latest news on the exciting road to
                the make AI help us learn and teach better.
                <div style={{ marginTop: '3rem' }} />
                Subscribe to our newsletter here!
            </DialogContentText>
            <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Email Address"
                type="email"
                // fullWidth
                inputRef={emailRef}
            />
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary">
                Cancel
            </Button>
            <Button onClick={(props) =>
                {handleClose()
                addEmail(props)}
                } color="primary">
                Subscribe
            </Button>
            </DialogActions>
        </Dialog>
        </div>
    );
}

export default Subscribe;